import React from 'react';
import { Typography } from 'common/components';
import { createElementKey } from 'utils';
import { FEATURE_LIST, FeatureStructure } from './features-section-constants';
import { feature, featureImg, featureText, featuresSection } from './features-section-styles';

/**
 * Вью секции со списком особенностей проектирования
 */
export const FeaturesSection = () => (
  <section className={featuresSection}>
    {FEATURE_LIST.map(({ alt, src, text }: FeatureStructure, index: number) => (
      <div className={feature} key={createElementKey('feature', index)}>
        <img alt={alt} title={alt} src={src} className={featureImg} />
        <Typography variant="m" size="body_long" className={featureText}>
          {text}
        </Typography>
      </div>
    ))}
  </section>
);
